import React from "react";
import {
  MTSHeader,
  MTSBody,
  MTSFooter,
  MTSBodyRowGrouped
} from "./components/MarketTemplateSkeletonSections";

export const MarketTemplateSkeleton = ({showHeader = true, showFooter = true, animation = true, type }) => {
  if (type === "rowgrouped") {
    return (    <div className="cui-w-auto">
      { showHeader ? <MTSHeader animation={animation} /> : null}
      <MTSBodyRowGrouped animation={animation} />
      <MTSBodyRowGrouped animation={animation} />
      <MTSBodyRowGrouped animation={animation} />
      {/* { showFooter ? <MTSFooter animation={animation} /> : null } */}
    </div>

    )
  }
  return (
    <div className="cui-w-auto">
      { showHeader ? <MTSHeader animation={animation} /> : null}
      <MTSBody width="25%" animation={animation} />
      <MTSBody width="40%" animation={animation} />
      <MTSBody width="30%" animation={animation} />
      <MTSBody width="25%" animation={animation} />
      <MTSBody width="30%" animation={animation} />
      { showFooter ? <MTSFooter animation={animation} /> : null }
    </div>
  );
};
